import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { PolarisProjectTemplate } from '@atlassian/jira-polaris-domain-project/src/types.tsx';
import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';

export const getOnboardingInformation = (projectId: ProjectId): Promise<PolarisProjectTemplate> =>
	fetchJson(
		`/rest/polaris/project-template/onboarding-information/${projectId}?operation=getJpdOnboardingInformation`,
	);
